module.exports = __webpack_public_path__ + "img/txt_series_104.53de602c.png";